<div class='import-dialog'>
  <form [formGroup]="form" name="form" (ngSubmit)='submitImportProject()'>
    <div class="content-container create-item-container">
      <adm4-version-control-form [predefinedVersionControl]="predefinedVersionControlData()" (formReady)='addVersionControlForm($event)'></adm4-version-control-form>
      <div class="adm4-form-group">
        <label class='input-label'>Project key*</label>
        <div class="item-key-container">
          @if (displayTenant) {
            <div class='tenant-key-wrapper'>
              <span>{{selectedTenantKey}} - </span>
              <div class='validation-message-container'></div>
            </div>
          }
          <div class='item-key-input-wrapper'>
            <input class='admn4-text-input form-control'
              [class.errored]="form.controls[PROJECT_KEY_FORM_CONTROL_NAME].invalid"
              formControlName='projectKey'
              name="projectKey"
              required/>
            <div class='validation-message-container'>
              @if (shouldShowProjectKeyErrorMessage("pattern")) {
                <adm4-validation-message [isError]='true'
                [message]='ERROR_INVALID_PROJECT_KEY'></adm4-validation-message>
              }
              @if (shouldShowProjectKeyErrorMessage("required")) {
                <adm4-validation-message [isError]='true'
                [message]='ERROR_PROJECT_KEY_REQUIRED'></adm4-validation-message>
              }
              @if (shouldShowProjectKeyErrorMessage("projectKeyExists")) {
                <adm4-validation-message [isError]='true'
                [message]='projectForTenantExistsError'></adm4-validation-message>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    <div mat-dialog-actions>
      <button type='button' class='admn4-button-text'
        (click)='cancelClicked.emit()'>
        Cancel
      </button>
      <button class='admn4-button-ellipse-blue'
        [disabled]='!canSave'>
        Import
      </button>
    </div>
  </form>
</div>
